import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';

const CACHE: any = {};

/** userid -> userName */
@Component({})
export default class UserName extends Vue {
  @Prop() private userId!: number;
  userName: string | undefined = '';
  mounted() {
    if (this.userId && CACHE[this.userId!]) {
      this.userName = CACHE[this.userId!];
    } else if (this.userId) {
      this.userName = `[${this.userId}...]`;
      this.fetchAsync(this.userId!);
    }
  }

  async fetchAsync(userid: number) {
    const { success, data } = { success: true, data: '' };//await api.sys_Account.userName_GET({ userId: userid });
    if (success) {
      this.userName = data;
      CACHE[userid] = data;
    } else {
      this.userName = `[${this.userId}]`;
    }
  }

  render() {
    return <span class="username">{this.userName}</span>;
  }
}
